import {HttpAxiosRequest} from "../httpAxiosBase";

export const HttpUser = {
    getEndpoint: (url = ''): string => `usuarios${url}`,

    logOut: () => {
        return HttpAxiosRequest.post(
            HttpUser.getEndpoint('/logout'), {}
        )
    },
}